import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JanelasEmpresaRoutingModule } from './janelas-empresa-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    JanelasEmpresaRoutingModule
  ]
})
export class JanelasEmpresaModule { }
